// ============================================================================
// rrefimi.js — RRËFIMTARI
//
// `tregimi.js` vendos ÇFARË hyn te historia. Ky skedar vendos SI DËGJOHET.
//
// ---------------------------------------------------------------------------
// PSE U DESH (27 gusht 2026)
//
// Pronari, pasi libri doli mirë:
//
//     "turneu prapë është kronologjik, ka shumë informacion dhe nuk është
//      tamam tregim."
//
// Kishte të drejtë, dhe shkaku ishte i imi: turneu me stilin `rrefim` merrte
// momentet e sakta nga motori, po pastaj i lexonte me të njëjtin ndërtues që
// kishte turneu klasik — një listë faktesh të ngjitura me pika:
//
//     "Naim Kelmendi. 1942. Lindur në Vermosh, Kelmend. Fëmijë i … .
//      Martuar me Fatime Kelmendi. Dega vazhdoi me 3. Naimi lindi në …"
//
// Kjo është një kartelë baze të dhënash e lexuar me zë. Te libri i njëjti
// problem nuk dukej, sepse aty faktet janë të vogla e gri dhe historia është
// trupi i faqes — syri i kapërcen. Veshi nuk kapërcen dot asgjë: çdo fjalë
// zë të njëjtën kohë.
//
// ---------------------------------------------------------------------------
// RREGULLI I VETËM QË E BËN TREGIM
//
//     KUR KA FJALË TË SHKRUARA NGA FAMILJA, FAKTET HESHTIN.
//     KUR S'KA, thuhet NJË fakt — jo katër.
//
// Sepse një fakt pa histori e mban rrëfimin në lëvizje; katër fakte pa histori
// e kthejnë në inventar. Dhe kur s'ka as njërin, heshtja thuhet me fjalë, nuk
// mbulohet: "për të s'ka mbetur asnjë fjalë e shkruar" është pjesë e rrëfimit
// të një familjeje, ndoshta më e vërteta.
//
// ---------------------------------------------------------------------------
// LIDHËSIT — ajo që e ndan rrëfimin nga lista
//
// Një listë thotë 1942, 1947, 1969. Një rrëfim thotë "pesë vjet më vonë" dhe
// "kaluan njëzet e dy vjet". E njëjta e dhënë, kohë e ndjeshme. Lidhësi nuk
// shpik asgjë: ai është zbritja e dy viteve që tashmë i kemi.
//
// ---------------------------------------------------------------------------
// PA GJUHË BRENDA
//
// Ky skedar NUK shkruan asnjë fjali. Ai kthen `{celes, vlerat}` dhe thirrësi i
// jep `t()`-së. Kështu shqipja dhe anglishtja rrinë te `locales/`, aty ku
// rrinë të gjitha të tjerat, dhe rrëfimtari mbetet i provueshëm me Node: prova
// pohon çelësin dhe vlerat, jo bukurinë e fjalisë.
//
// Provat: `node src/rrefimi.test.mjs`
// ============================================================================

// Sa vite e ndajnë një moment nga tjetri para se koha të meritojë fjalë.
const HERSHEM = 5;    // nën 5 vjet: "pak vite më vonë"
const GJATE = 15;     // mbi 15 vjet: "kaluan X vjet"
// Kur fija këputet, koha thuhet me fjali të plotë — po vetëm nga tri vjet e
// lart. "Kaluan 1 vit." mes dy degëve të palidhura është zhurmë.
const KUFI_HESHTJES = 3;

const gjalle = (p) => p && !p.deleted_at;
const emriPlote = (p) =>
  [p?.first_name, p?.last_name].filter(Boolean).join(" ").trim() || "";
const vendiKryesor = (s) => String(s || "").split(",")[0].trim();

// PRERJA PËR VESHIN
//
// Libri e shtyp historinë të plotë; zëri jo — një bio prej 4000 shenjash bëhet
// tre minuta për një hap, dhe Azure e ka kufirin e vet. Pritet te fundi i një
// fjalie, kurrë në mes të saj: "…u nis me familjen drejt Kuk" është më keq se
// asgjë. Nëse s'gjendet fundi i një fjalie, vihet një pauzë e dukshme.
export function prej(teksti, maks) {
  const t0 = String(teksti || "").trim();
  if (!maks || t0.length <= maks) return { teksti: t0, u_pre: false };
  const copa = t0.slice(0, maks);
  const fundi = Math.max(copa.lastIndexOf("."), copa.lastIndexOf("!"), copa.lastIndexOf("?"));
  return fundi > maks * 0.15
    ? { teksti: copa.slice(0, fundi + 1), u_pre: true }
    : { teksti: copa.trim() + "…", u_pre: true };
}

// ---------------------------------------------------------------------------
// LIDHËSI — dhe rregulli që u desh të mësohej me shtrenjtë
//
// GABIMI (raportuar 27 gusht)
//
//     "Martesa e Naimit dhe Fatimes — 1966."
//     "4 vjet më vonë, më 1970 lindi Fatime Kelmendi."
//
// Te kjo familje ka DY Fatime. Të dyja fjalitë janë të vërteta veç e veç. Fjala
// «më vonë» i bashkoi: veshi e lidh atë që vjen pas një lidhësi me subjektin që
// sapo u përmend, dhe rrëfimi tha se gruaja u lind katër vjet pasi u martua.
//
// Rrëfimi gënjeu pa shqiptuar asnjë fakt të rremë — dhe kjo është e vetmja
// mënyrë si mund të gënjejë një rrëfim i ndërtuar mbi të dhëna të sakta.
//
// ---------------------------------------------------------------------------
// DY LLOJE LIDHËSISH, DHE VETËM NJËRI LIDH SUBJEKTE
//
//   FJALI E PLOTË     "Kaluan 19 vjet."      Flet për kohën. Nuk i vë subjekt
//                                            fjalisë tjetër. E sigurt gjithmonë.
//
//   COPË FJALIE       "4 vjet më vonë,"      Fjalia që vjen pas e trashëgon
//                     "Në të njëjtin vit,"   subjektin e mëparshëm. E lejuar
//                                            VETËM kur fija vërtet vazhdon.
//
// Fija vazhdon kur të dy momentet ndajnë të paktën një person — ose kur të dy
// janë ngjarje të vetë familjes, sepse ato e kanë familjen si subjekt të
// përbashkët dhe kjo është e vërtetë me përkufizim.
//
// Kur fija këputet, mbetet vetëm zbrazëtira: pa lidhës. Momenti e mban vitin te
// fjalia e vet ("Më 1970 lindi …"), pra koha nuk humbet — humbet vetëm pretendimi
// se e dyta rrjedh nga e para. Dhe ai pretendim ishte e gjithë gënjeshtra.
// ---------------------------------------------------------------------------
function fijaVazhdon(m, iMeparshem) {
  if (!iMeparshem) return false;
  if (m.lloj === "familje" && iMeparshem.lloj === "familje") return true;
  const a = m.aktoret || m.personIds || [];
  const b = iMeparshem.aktoret || iMeparshem.personIds || [];
  return a.some((id) => b.includes(id));
}

function lidhesi(vit, vitiMeParshem, iPariIKapitullit, vazhdon) {
  if (vitiMeParshem == null || vit == null) return null;
  // Te fillimi i një kapitulli flet kapitulli, jo ora. Dy zëra për të njëjtën
  // kthesë do të tingëllonin si belbëzim.
  if (iPariIKapitullit) return null;
  const d = vit - vitiMeParshem;
  if (d < 0) return null;              // të dhëna të prishura — hesht, mos gënje

  if (!vazhdon) {
    // Fija u këput. Lejohet vetëm fjalia e plotë për kohën e kaluar, sepse ajo
    // s'i vë subjekt fjalisë tjetër — dhe as ajo kur vitet janë një ose dy, se
    // atëherë s'ka çfarë të thuhet për kohën.
    //
    // Pa këtë degë rrëfimi do të hiqte çdo lidhës sa herë kalon nga një degë
    // te tjetra, dhe do të bëhej listë e copëtuar — pikërisht e keqja që
    // donim të shmangnim. Ritmi mbahet, pretendimi bie.
    return d >= KUFI_HESHTJES ? { celes: "rr.lidh.kaluan", vlerat: { sa: d } } : null;
  }

  if (d === 0) return { celes: "rr.lidh.njejtiVit", vlerat: {} };
  // «1 vjet më vonë» nuk është shqip. Njëshi e ka fjalinë e vet.
  if (d === 1) return { celes: "rr.lidh.njeVit", vlerat: { sa: 1 } };
  if (d < HERSHEM) return { celes: "rr.lidh.pakVite", vlerat: { sa: d } };
  if (d < GJATE) return { celes: "rr.lidh.viteMeVone", vlerat: { sa: d } };
  return { celes: "rr.lidh.kaluan", vlerat: { sa: d } };
}

// ---------------------------------------------------------------------------
// FJALIA KORNIZË — një për çdo arsye zgjedhjeje
//
// Lidhet me `pse`, jo me `lloj`: rrënja dhe dikush-me-histori janë të dy
// `lindje`, dhe po t'i thoshim njësoj, rrëfimi do të "niste" pesë herë. I
// njëjti mësim që libri e mori më 26 gusht.
// ---------------------------------------------------------------------------
function korniza(m, p, brezi, vendiVjeter, ePara) {
  const emri = p ? emriPlote(p) : "";
  const vendi = p ? vendiKryesor(p.birth_place) : (m.vend || "");
  const v = { emri, viti: m.vit, vendi };

  switch (m.pse) {
    case "paraardhesi_me_i_vjeter":
      return vendi ? { celes: "rr.rrenja.vend", vlerat: v }
                   : { celes: "rr.rrenja.paVend", vlerat: v };
    case "ka_histori_te_shkruar":
      if (m.lloj === "vdekje") return { celes: "rr.vdekje", vlerat: v };
      return vendi ? { celes: "rr.lindje.vend", vlerat: v }
                   : { celes: "rr.lindje.paVend", vlerat: v };
    case "ndarja_e_dikujt_me_histori":
      return { celes: "rr.vdekje", vlerat: v };
    case "lindja_e_pare_ne_nje_vend_te_ri":
      // «Po jo në Vermosh — në Pejë» thotë diçka; «po diku tjetër» nuk thotë
      // asgjë. Vendi i mëparshëm vjen nga udhëtimi, që motori e ka renditur
      // tashmë sipas kohës; kur s'ka të mëparshëm (ndalesa e dytë e një
      // familjeje pa vendlindje të shënuar), përdoret fjalia pa krahasim.
      //
      // DHE VETËM HERËN E PARË SHPJEGOHET. Fjalia "kështu duket një zhvendosje
      // te një pemë" është e bukur një herë; e treta herë brenda dy minutash
      // e kthen rrëfimin në leksion. Prova e printoi rrëfimin të plotë dhe
      // përsëritja u pa me sy — prandaj printohet.
      if (!vendiVjeter) return { celes: "rr.zhvendosje.paVjeter", vlerat: { ...v, vendi: m.vend || vendi } };
      return {
        celes: ePara ? "rr.zhvendosje" : "rr.zhvendosje.perseri",
        vlerat: { ...v, vendi: m.vend || vendi, vendiVjeter },
      };
    case "fillimi_i_nje_brezi":
      return { celes: "rr.brez", vlerat: { ...v, nr: brezi || 2 } };
    case "shkruar_nga_familja":
    default:
      return { celes: "rr.familje", vlerat: { titulli: m.titull || "", viti: m.vit } };
  }
}

// ---------------------------------------------------------------------------
// SHTESA — NJË fakt, dhe vetëm kur s'ka fjalë të shkruara
//
// Radha nuk është e rastit: fëmijët e çojnë rrëfimin PARA, prindërit e lidhin
// me atë që sapo u tha, bashkëshorti e vendos në një familje. Heshtja vjen e
// fundit, dhe thuhet hapur.
// ---------------------------------------------------------------------------
function shtesa(p, people, m, emriPerseritet) {
  if (!p) return null;
  // Te një zhvendosje korniza e ka emëruar personin, vitin dhe të dy vendet —
  // një fakt i pestë aty nuk e çon rrëfimin askund. Te një ngjarje familjare
  // fjalët janë tashmë të familjes.
  if (m && (m.lloj === "zhvendosje" || m.lloj === "familje")) return null;
  const emri = (id) => (people[id] && gjalle(people[id]) ? emriPlote(people[id]) : null);

  const prind = (p.parent_ids || []).map(emri).filter(Boolean);
  // KUR EMRI PËRSËRITET, PRINDËRIT VIJNË TË PARËT.
  //
  // Te një familje me dy Fatime, "Dega vazhdoi me 3" nuk thotë se cila Fatime
  // është kjo. "Fëmijë i Rexhepit dhe Teutës" e thotë. Kur emri është i vetëm,
  // rradha mbetet si më parë: fëmijët e çojnë rrëfimin para.
  if (emriPerseritet && prind.length) {
    return { celes: "rr.shtese.prinder", vlerat: { emrat: prind.join(", ") } };
  }

  const femije = Object.values(people).filter(
    (x) => gjalle(x) && (x.parent_ids || []).includes(p.id)
  ).length;
  if (femije) return { celes: "rr.shtese.femije", vlerat: { sa: femije } };

  if (prind.length) return { celes: "rr.shtese.prinder", vlerat: { emrat: prind.join(", ") } };

  const bashk = (p.spouse_ids || []).map(emri).filter(Boolean);
  if (bashk.length) return { celes: "rr.shtese.bashkeshort", vlerat: { emrat: bashk.join(", ") } };

  return { celes: "rr.shtese.heshtje", vlerat: { emri: emriPlote(p) } };
}

// ---------------------------------------------------------------------------
// HYRJA — çfarë po dëgjon, dhe pse pikërisht kjo pjesë
//
// Kur fusha është e ngushtuar, kjo fjali është e detyrueshme: pa të, dikush që
// zgjodhi "vetëm Learti dhe pasardhësit" do të mendonte se familja ka pesë
// veta dhe se programi i humbi të tjerët.
// ---------------------------------------------------------------------------
function hyrja(tregimi, familja) {
  const f = tregimi.fusha || { lloj: "gjithe" };
  const rreshtat = [{
    celes: "rr.hyrja",
    vlerat: { familja: familja || "", nga: tregimi.nga, deri: tregimi.deri },
  }];
  if (f.lloj && f.lloj !== "gjithe") {
    rreshtat.push({
      celes: `rr.hyrja.fusha.${f.lloj}`,
      vlerat: { emri: f.emriNga || "", nga: f.emriNga || "", deri: f.emriDeri || "", sa: f.saJashte || 0 },
    });
  }
  return rreshtat;
}

function mbyllja(tregimi) {
  return [{
    celes: "rr.mbyllja",
    vlerat: {
      breza: tregimi.brezat.length,
      vende: tregimi.vendet.length,
      persona: tregimi.saPersona,
      momente: tregimi.momentet.length,
    },
  }];
}

/**
 * Kthen rrëfimin e gatshëm për t'u folur dhe për t'u shfaqur.
 *
 * @param {Object}  o
 * @param {Object}  o.tregimi   — dalja e `ndertoTregimin`
 * @param {Object}  o.people    — harta e personave (e njëjta që i dha motorit)
 * @param {string}  o.familja   — emri i familjes, për hyrjen
 * @param {number}  o.maksTeksti— sa shenja lejohen për një histori (0 = pa kufi)
 * @returns {{hyrja, mbyllja, hapat, bosh, arsyeja}}
 */
export function ndertoRrefimin({ tregimi, people = {}, familja = "", maksTeksti = 0 } = {}) {
  const f = tregimi?.fusha || { lloj: "gjithe" };

  // Fushë e pamundur — kjo NUK kthehet si rrëfim bosh. Përdoruesi zgjodhi
  // diçka që pema s'e mban, dhe duhet ta dëgjojë pse, jo të shohë një shirit
  // që hapet e mbyllet pa thënë asgjë.
  if (f.bosh && f.arsyeja) {
    return {
      bosh: true, arsyeja: f.arsyeja, hapat: [], mbyllja: [],
      hyrja: [{
        celes: `rr.bosh.${f.arsyeja}`,
        vlerat: { nga: f.emriNga || "", deri: f.emriDeri || "" },
      }],
    };
  }
  if (!tregimi || !tregimi.momentet.length) {
    return { bosh: true, arsyeja: "pa_momente", hapat: [], mbyllja: [],
             hyrja: [{ celes: "rr.bosh.pa_momente", vlerat: {} }] };
  }

  // Udhëtimi është i renditur sipas kohës; ndalesa para kësaj është vendi nga
  // ku u shpërngul familja.
  const rradha = (tregimi.vendet || []).map((v) => v.emri);
  const vendiPara = (m) => {
    if (m.lloj !== "zhvendosje" || !m.vend) return null;
    const i = rradha.indexOf(m.vend);
    return i > 0 ? rradha[i - 1] : null;
  };

  // Cilët emra përsëriten brenda KËTIJ rrëfimi. Jo brenda familjes: nëse te
  // rrëfimi del vetëm një Fatime, s'ka pse sqarohet asgjë.
  const saHere = {};
  tregimi.momentet.forEach((m) => (m.personIds || []).forEach((id) => {
    const e = (people[id]?.first_name || "").toLowerCase().trim();
    if (e) saHere[e] = (saHere[e] || new Set()).add(id);
  }));
  const emriPerseritet = (p) => {
    const e = (p?.first_name || "").toLowerCase().trim();
    return !!e && (saHere[e]?.size || 0) > 1;
  };

  const kapPerMoment = {};
  tregimi.kapitujt.forEach((k) => { kapPerMoment[k.momentIds[0]] = k; });
  const brezPerPerson = {};
  tregimi.brezat.forEach((b) => b.personIds.forEach((id) => { brezPerPerson[id] = b.nr; }));

  let vitiMeParshem = null;
  let iMeparshem = null;
  let zhvendosjeTeShkuara = 0;
  const hapat = tregimi.momentet.map((m) => {
    const p = m.personIds[0] ? people[m.personIds[0]] : null;
    const k = kapPerMoment[m.id] || null;
    const iPari = !!k;

    const pre = prej(m.teksti, maksTeksti);
    const ka = !!pre.teksti;

    const hap = {
      id: p ? p.id : null,
      vit: m.vit,
      lloj: m.lloj,
      pse: m.pse,
      aktoret: m.aktoret || m.personIds || [],
      emri: p ? emriPlote(p) : (m.titull || ""),
      vend: m.vend || (p ? vendiKryesor(p.birth_place) : null) || null,
      kap: k ? { celes: `rr.kap.${k.celes}`, vlerat: { nga: k.nga, deri: k.deri, vend: k.vend || "" } } : null,
      lidhesi: lidhesi(m.vit, vitiMeParshem, iPari, fijaVazhdon(m, iMeparshem)),
      fjalia: korniza(m, p, brezPerPerson[p?.id], vendiPara(m), zhvendosjeTeShkuara === 0),
      // Fjalët e familjes shkojnë ashtu siç janë shkruar. Kjo nuk përkthehet
      // dhe nuk redaktohet: nuk janë tonat.
      teksti: pre.teksti,
      u_pre: pre.u_pre,
      // Fakti i vetëm — vetëm kur heshtja do të ishte e vetmja gjë tjetër.
      shtese: ka ? null : shtesa(p, people, m, emriPerseritet(p)),
    };
    vitiMeParshem = m.vit;
    iMeparshem = m;
    if (m.lloj === "zhvendosje") zhvendosjeTeShkuara++;
    return hap;
  });

  return { bosh: false, arsyeja: null, hyrja: hyrja(tregimi, familja), mbyllja: mbyllja(tregimi), hapat };
}

/**
 * E gjithë fjalia e një hapi, si një varg — për zërin dhe për titrat.
 * `perkthe` është `t()`-ja e thirrësit; pa të kthehen vetëm çelësat, gjë që
 * e bën provën të lexueshme.
 */
export function fjaliaEHapit(hap, perkthe) {
  const p = (x) => (x ? (perkthe ? perkthe(x.celes, x.vlerat) : x.celes) : null);
  return [p(hap.lidhesi), p(hap.fjalia), hap.teksti, p(hap.shtese)]
    .filter(Boolean)
    .map((s) => String(s).trim())
    .filter(Boolean)
    .join(" ");
}
